const education = [
  {
    university: "Northeastern University",
    school: "Khoury College of Computer Sciences",
    location: "Boston, Massachusetts",
    degree: "MS Computer Science",
    duration: "2023 - Dec 2025",
    major: "Computer Science",
  },
  {
    university: "Vellore Institute of Technology",
    school: "School of Computer Science and Engineering (SCOPE)",
    location: "Vellore, Tamil Nadu",
    degree: "B.Tech Computer Science",
    duration: "2016 - 2020",
    major: "Computer Science",
  },
];

export default education;
